import { AppRoutingModule } from './app.routing';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../@core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';

import { GOOGLEMAP_KEY } from '../@shared/constants';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthGuardService } from 'src/@core/http/auth/auth-guard.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from 'src/@core/http/interceptors/token.interceptor';
import { AuthService } from 'src/@core/http/auth/auth.service';
import { AuthSignedInGuardService } from 'src/@core/http/auth/auth-signedin-guard.service';
import { RouterModule } from '@angular/router';
//import { GoogleMapsModule } from '@angular/google-maps'


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    //GoogleMapsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    NgxSpinnerModule,
    ChartsModule,
    RouterModule,
    CoreModule.forRoot(),
    NgbModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    TranslateModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: GOOGLEMAP_KEY
    })
  ],
  providers: [
    NgbActiveModal,
    AuthGuardService,
    AuthSignedInGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    AuthService, GoogleMapsAPIWrapper
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
